/** Packed-audit quantities. Thousandths, matching on-hand snapshots. */

export function roundWalkQty(value: number): number {
  return Number((value + Number.EPSILON).toFixed(3));
}

export function roundWalkCost(value: number): number {
  return Number((value + Number.EPSILON).toFixed(4));
}

export type PackedAuditKind = "write_off" | "found" | "even";

export type PackedAuditDelta = {
  auditedOnHand: number;
  deltaQty: number;
  kind: PackedAuditKind;
};

/** Audited on-hand is packed plus bays. Delta is audited minus the books. */
export function packedAuditDelta(bookOnHand: number, packedQty: number, bayQty: number): PackedAuditDelta {
  const packed = roundWalkQty(packedQty);
  const bay = roundWalkQty(bayQty);
  const auditedOnHand = roundWalkQty(packed + bay);
  const deltaQty = roundWalkQty(auditedOnHand - roundWalkQty(bookOnHand));
  const kind: PackedAuditKind = deltaQty < -0.0005 ? "write_off" : deltaQty > 0.0005 ? "found" : "even";
  return { auditedOnHand, deltaQty, kind };
}

export function reversalQty(deltaQty: number): number {
  return roundWalkQty(-deltaQty);
}

export function packedAuditNotes(sessionId: string, kind: "write_off" | "found" | "reversal"): string {
  if (kind === "write_off") return `Packed audit ${sessionId} — tentative write-off`;
  if (kind === "found") return `Packed audit ${sessionId} — found stock`;
  return `Packed audit ${sessionId} — reversal`;
}

/** Remaining quantity of an unreverted write-off that salvage can put back. */
export function writeOffRemaining(deltaQty: number, returnedQty: number, reversed: boolean): number {
  if (reversed || deltaQty >= -0.0005) return 0;
  return roundWalkQty(Math.max(0, roundWalkQty(-deltaQty) - roundWalkQty(returnedQty)));
}
